import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { trigger, state, style, transition, animate, query, stagger, keyframes, group } from '@angular/animations';
import { Subscription } from 'rxjs';
import { ResponsiveService } from 'src/app/tools/services/responsive.service';

let SIDEBAR_COLLAPSED_WIDTH="25px"
let SIDEBAR_WIDTH="200px"
@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  animations : [
    trigger('collapse',[
      state('normal', style({
        'min-width': SIDEBAR_WIDTH
      })),
      state('collapsed', style({
        'min-width': SIDEBAR_COLLAPSED_WIDTH
      })),
      transition('collapsed => normal', [
        group([
          query('@slideLogo',
          animate('.5s ease', keyframes([
            style({ transform: 'translateX(-75px)'}),
            style({ transform: 'translateX(-25px)'}),
            style({ transform: 'translateX(0px)'})
          ]))
        , {optional: true}),
          animate('0.5s ease',keyframes([
            style({ 'min-width' : SIDEBAR_COLLAPSED_WIDTH }),
            style({ 'min-width' : '120px' }),
            style({ 'min-width' : SIDEBAR_WIDTH }),
          ]))
        ])
      ]),
      transition('normal => collapsed', [
        group([
          query('@slideLogo',
          animate('.5s ease', keyframes([
            style({ transform: 'translateX(0px)'}),
            style({ transform: 'translateX(-25px)'}),
            style({ transform: 'translateX(-75px)'})
          ]))
        , {optional: true}),
          animate('0.5s ease',keyframes([
            style({ 'min-width' : SIDEBAR_WIDTH }),
            style({ 'min-width' : '60px' }),
            style({ 'min-width' : SIDEBAR_COLLAPSED_WIDTH }),
          ]))
        ])
      ]),
    ])
    ,
    trigger('slideLogo',[
      state('normal', style({
        opacity: 0, transform: 'translateX(0px)'}
      )),
      state('collapsed', style({
        opacity: 1, transform: 'translateX(-75px)'
      })),
      transition('appear<=>disappear',[
        animate('0.5s')
      ])
    ])
  ]
}
)

export class LayoutComponent implements OnInit {

  shrinkMode  : boolean = false;
  show        : boolean = false;
  isMobile    : boolean = false;

  // This variable is used to show or hide the searchbar
  searchBarIsVisible  : boolean = false;
  isSideBarVisible    : boolean = true;
  subscription        : Subscription;

  constructor(
    protected router              : Router,
    protected activatedRoute      : ActivatedRoute,
    protected responsiveService   : ResponsiveService,
    public userService            : UserService,
  ) { 

    this.subscription = this.router.events.subscribe(() => {
      this.isSideBarVisible=false;
    });

    this.responsiveService.getMobileStatus().subscribe( isMobile =>{
      this.isMobile = isMobile;
    });
    
  }

  ngOnInit() {    
    this.onResize(null);   
  }

  onResize(e: any){
    this.responsiveService.checkWidth();
  }

  userName(){
    if (! this.userService.userInfo) return "";
    let result = "";
    if (this.userService.userInfo.person.firstName) {
      result = this.userService.userInfo.person.firstName + " ";
    }
    if (this.userService.userInfo.person.name) {
      result = this.userService.userInfo.person.name;
    }

    return result;
  }
  toggleSideNav() {
    this.shrinkMode = ! this.shrinkMode;
    if(this.isMobile){
      this.isSideBarVisible=!this.isSideBarVisible
    }
  }

  toggleFullScreen() {
    if(document.fullscreenEnabled) {
      if(!document.fullscreenElement) {
        document.body.requestFullscreen();
      }
      else {
        document.exitFullscreen();
      }
    }
  }

  toggleSearchBar(value: boolean) {
    this.searchBarIsVisible = value;
  }

  logout(){
    this.userService.userInfo = null;
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscription.unsubscribe();
  }
}
